import React from 'react';
import { useBanners } from '../../../context/banners';

export const useBanner = (bannerId: string | null) => {
  const { allBanners } = useBanners();

  return React.useMemo(() => {
    if (!bannerId) return null;
    return allBanners.find(banner => banner.bannerId === bannerId) || null;
  }, [allBanners, bannerId]);
};
